import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './affirm-as-low-as-display.less';

class AffirmAsLowAsDisplay extends Component {
  componentDidMount() {
    // Try to refresh, otherwise wait for Affirm to load before refreshing
    try {
      window.affirm.ui.refresh();
    } catch (e) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.amount !== this.props.amount) {
      try {
        window.affirm.ui.refresh();
      } catch (e) {
        window.affirm.ui.ready(() => {
          window.affirm.ui.refresh();
        });
      }
    }
  }

  render() {
    const {
      affirmColor,
      affirmType,
      amount,
      hideLearnMore,
      pageType,
    } = this.props;
    return (
      <p
        className={`AffirmAsLowAsDisplay affirm-as-low-as ${pageType}`}
        data-amount={`${amount * 100}`}
        data-page-type={pageType}
        data-affirm-color={affirmColor}
        data-affirm-type={affirmType}
        data-learnmore-show={`${!hideLearnMore}`} />
    );
  }
}


AffirmAsLowAsDisplay.propTypes = {
  affirmColor: PropTypes.oneOf(['black', 'white']),
  affirmType: PropTypes.oneOf(['text', 'symbol']),
  amount: PropTypes.number.isRequired,
  hideLearnMore: PropTypes.bool,
  pageType: PropTypes.string,
};

AffirmAsLowAsDisplay.defaultProps = {
  affirmColor: undefined,
  affirmType: undefined,
  hideLearnMore: false,
  pageType: null,
};

export default AffirmAsLowAsDisplay;



// WEBPACK FOOTER //
// ./app/common/components/affirm/affirm-as-low-as-display.jsx